import { projectService } from "../_services/project.service";
import { localstorageSession } from "../_helpers/localstorage-session";

const projects_session = JSON.stringify(localStorage.getItem("projects"));
const project_session = localStorage.getItem("project");
const projectschildren_session = localStorage.getItem("projectschildren");
// localStorage.removeItem('localLatestProj')
const localLatestProj = JSON.parse(localStorage.getItem('localLatestProj')) || [];

const initialStateDefault = () => {
  return {
    projects: projects_session ? projects_session : null,
    project: project_session ? project_session : null,
    projectsChildren: projectschildren_session ? projectschildren_session : []
  };
};

export const project = {
  namespaced: true,
  state: {
    projects: initialStateDefault().projects,
    project: initialStateDefault().project,
    projectschildren: initialStateDefault().projectsChildren,
    inproject: false,
    name: {},
    tab_ref: [],
    project_selected: null,
    latestProj: localLatestProj
  },
  getters: {
    getLatestProj: state => state.latestProj,
    getProject: state => {
      return state.project;
    },
    getProjects: state => {
      return state.projects;
    },
    getName: state => {
      return state.name;
    },
    inProject: state => {
      return state.inproject;
    },
    getProjectsWithParent: state => {
      if (state.project != null) {
        return state.projects.filter(element => {
          if (element.parent === state.project.uuid) return element;
        });
      } else {
        return null;
      }
    },

    getProjectsSansParent: async state => {
      let projects = [];
      if (!Array.isArray(state.projects)) {
        projects = JSON.parse(JSON.parse(state.projects));
      } else {
        projects = state.projects;
      }
      if (projects != null) {
        let test = projects.filter(element => {
          return element != undefined && element.parent == null;
        });
        return test.slice(0, 4);
      } else {
        return null;
      }
    },
    getDirectories: state => {},
    getTabRef: state => {
      return state.tab_ref;
    }
  },
  mutations: {
    setLatestProj: (state,lastProj) => {  // lastProj = {}
      if (!lastProj) return;
      let index = state.latestProj.findIndex((proj) => proj.uuid === lastProj.uuid);
      if (index !== -1)
        state.latestProj.splice(index, 1);
      state.latestProj.unshift(lastProj);
      if (state.latestProj.length > 5)
        state.latestProj.pop();
      localStorage.setItem('localLatestProj', JSON.stringify(state.latestProj));
    },
    addProject(state, newProject) {
      state.projects.push(newProject);
      
      state.project = newProject;
      localstorageSession("projects", state.projects);
      localstorageSession("project", newProject);
    },
    setProject(state, newProject) {
      state.project = newProject;
      localstorageSession("project", newProject);
    },
    setName(state, newName) {
      state.name = newName;
    },
    setProjects(state, projects) {
      state.projects = projects;
      localstorageSession("projects", state.projects);
    },
    setInProject(state, inProject) {
      state.inproject = inProject;
    },
    delProject(state, uuid) {
      let index = state.projects.findIndex(item => item.uuid === uuid);
      if (index !== -1) {
        state.projects.splice(index, 1);
      }
      localstorageSession("projects", state.projects);
      index = state.latestProj.findIndex(proj => proj.uuid === uuid);
      if (index !== -1) {
        state.latestProj.splice(index, 1);
        localStorage.setItem('localLatestProj', JSON.stringify(state.latestProj));
      }
    }
  },
  actions: {
    createProject({ dispatch, commit, getters }, data) {
      return new Promise(async (resolve) => { 
        let newProj = await projectService.createProject(data)
        commit("addProject", newProj);
        resolve(newProj);
      })
    },
    async getProjects({ dispatch, commit, getters }) {
      var projects = await projectService.getProjects();
      projects = projects.data.results;
      commit("setProjects", projects);
      return projects;
    },
    async getProject({ dispatch, commit }, uuid) {
      let resp = await projectService.getProject(uuid);
      return resp;
    },
    async delProject({ dispatch, commit, getters }, uuid) {
      try {
        await projectService.delProject(uuid)
        commit("delProject", uuid);
      }
      catch (err){
        console.error(err);
        // commit("loginFailure", error);
        // dispatch("alert/error", error, { root: true });
      }
    },
    inProject({ commit }, inProject) {
      commit("setInProject", inProject);
    }
  }
};
